export const blockDefaultColor = '#353E47'
export const blockHoverColor = '#353E47'
